import { FC, ReactNode } from "react";
import { Link } from "react-router-dom";

const Button: FC<
  {
    color?: string;
    disabled?: boolean;
    buttonWidth?: string;
    buttonMarginLeft?: string;
    style?: object;
    children: ReactNode;
  } & ({ onClick: () => void; to?: undefined } | { onClick?: undefined; to: string })
> = ({ buttonWidth = "90%", buttonMarginLeft = "5%", color = "#444", style = {}, onClick, to, disabled = undefined, children }) => {
  const css = {
    width: buttonWidth,
    marginLeft: buttonMarginLeft,
    marginRight: "5%",
    marginBottom: 10,
    height: 35,
    backgroundColor: color,
    ...style,
  };
  if (to !== undefined) {
    return (
      <Link
        to={to}
        className={"button button-fill " + (disabled ? "disabled" : "")}
        style={{ ...css, paddingTop: 5, textDecoration: "none" }}
      >
        {children}
      </Link>
    );
  } else {
    return (
      <button onClick={onClick} className="button button-fill" style={css} disabled={disabled}>
        {children}
      </button>
    );
  }
};

export default Button;
